import CommentForAnonymous from './CommentForAnonymous';
export default CommentForAnonymous;
